import appConstants from '../config/app_config';
const baseRoute = appConstants.baseRoute;
const ROUTES = {
  BASE: `${baseRoute}`,
  EXPLORER: `${baseRoute}Explorer`,
  EXPLORER_STEP1: `${baseRoute}Explorer/step1`,
  EXPLORER_STEP2: `${baseRoute}Explorer/step2`,
  NOTICEGEN: `${baseRoute}NoticeGeneratorPhaseOne`,
  NOTICEGEN_STEP1: `${baseRoute}NoticeGeneratorPhaseOne/step1`,
  NOTICEGEN_STEP2: `${baseRoute}NoticeGeneratorPhaseOne/step2`,
  LANDLORD_VALIDATOR: `${baseRoute}LandlordValidator`,
  TENANT_VALIDATOR: `${baseRoute}TenantValidator`,
  RENT_INCREASE_CALCULATOR: `${baseRoute}RentIncreaseCalculator`
};

export default ROUTES;
